module.exports = __webpack_public_path__ + "media/images/background-photo-2@1x-386dbd8bfdc5ce8734aa663992142ef4.png";